import gql from 'graphql-tag';

import { PurchasedCustomPrintFullDetails } from '../fragments/custom-prints';

export const purchasedCustomPrintUpdate = gql`
  mutation purchasedCustomPrintUpdate(
    $input: PurchasedCustomPrintUpdateInput!
  ) {
    purchasedCustomPrintUpdate(input: $input) {
      purchased_custom_print {
        ...PurchasedCustomPrintFullDetails
      }
    }
  }
  ${PurchasedCustomPrintFullDetails}
`;

export const purchasedCustomPrintsToPdf = gql`
  mutation purchasedCustomPrintsToPdf(
    $input: PurchasedCustomPrintsToPdfInput!
  ) {
    purchasedCustomPrintsToPdf(input: $input) {
      print_file_url
      print_file_download_url
    }
  }
`;

export const accountCustomPrintTierCreate = gql`
  mutation accountCustomPrintTierCreate(
    $input: AccountCustomPrintTierCreateInput!
  ) {
    accountCustomPrintTierCreate(input: $input) {
      account_custom_print_tier {
        id
        account {
          id
          custom_print_tiers {
            total
          }
        }
      }
    }
  }
`;
